import { render } from "./ViewJobSeeker.vue?vue&type=template&id=1bd85c54&scoped=true"
import script from "./ViewJobSeeker.vue?vue&type=script&lang=js"
export * from "./ViewJobSeeker.vue?vue&type=script&lang=js"

import "./ViewJobSeeker.vue?vue&type=style&index=0&id=1bd85c54&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd85c54"]])

export default __exports__